import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastTestsHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';
import { campaignExperimentRedirect } from './-campaign-experiment-redirects';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests',
)({
  component: JourneysBroadcastTestsHandoff,
  beforeLoad: campaignExperimentRedirect(),
});
